<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    :width="$vuetify.breakpoint.mdAndDown ? '95%' : '80%'"
    :formErrors="formErrors"
    :loading="loading"
    addButtonIcon="mdi-tractor"
    :inlineAddButton="inlineAddButton"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :newCreateButtonLabel="newCreateButtonLabel"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :planningOperation="planningOperation"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    planningOperation: {
      default: null,
      type: Object
    },
    inlineAddButton: {
      default: false,
      type: Boolean
    },
    newCreateButtonLabel: {
      type: String,
      default: "Realizar Operação"
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      if (this.planningOperation){        
        this.$apollo
          .query({
            query: LOAD_EXECUTION_OPERATION_FROM_PLANNING_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              planningOperationId: this.planningOperation.id
            }
          })
          .then(response => {            
            this.entry = response.data.groundContext.executionOperationFromPlanning;
            // this.entry.addressAttributes = response.data.accountContext.address;
            this.extraData = response.data;
            // console.log("exec ope entry",  this.entry);
            if (this.entry.initializationErrors.length){
              this.formErrors = this.entry.initializationErrors;              
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));        
      }else{
        this.$apollo
          .query({
            query: LOAD_EXECUTION_OPERATION_QUERY,
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.entry = response.data.groundContext.executionOperation;
            // this.entry.addressAttributes = response.data.accountContext.address;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
        }
    },
    createServerEntry: function(executionOperation) {
      // console.log("executionOperation", executionOperation, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(executionOperation, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_EXECUTION_OPERATION_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(executionOperation, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createExecutionOperation.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      this.formErrors = []
      if (this.planningOperation) {
        for(let consumedItemIndex in this.entry.exitMovementItemsAttributes) {
          let consumedItem = this.entry.exitMovementItemsAttributes[consumedItemIndex];
          if (consumedItem._destroy != true) {
            if (consumedItem.hasItemInStorage == false) {
              this.formErrors.push("O item de consumo " + consumedItem.item.name + " não está disponível em estoque!");
            }
            if (!consumedItem.storageId) {
              this.formErrors.push("O item " + consumedItem.item.name + " não possui estoque selecionado!");
            }
            if (!consumedItem.packagingId) {
              this.formErrors.push("O item " + consumedItem.item.name + " não possui embalagem selecionada!");
            }
          }
        }
      }
      
      if (this.formErrors.length == 0 && this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
      
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_EXECUTION_OPERATION_QUERY = gql `
  {
    groundContext {
      executionOperation {
        id
        operationTypeId        
        operationType {
          id
          name
          kind
        }
        periodIds
        periodIdsAttribute
        periods {
          id
          name
        }
        operationDate
        observation
        activitiesAttributes {
          id
          personId
          person {
            id
            name
          }
          durationInHours
          durationInMinutes
          durationText
          patrimonyId
          patrimony {
            id
            description
          }
          implementId
          implement {
            id
            description
          }
        }
        exitMovementItemsAttributes {
          id
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
          }
          packaging {
            id
            name
          }
          storage {
            id
            name
          }
          exitMovementItemLotsAttributes{
            id
          }
          hasCropLimit
          unitQuantity
          quantity
        }
        entryMovementItemsAttributes {
          id
         	itemId
          item {
            id
            name
            unit {
              id
              name
            }
          }
          quantity
          storageId
          storage {
            id
            name
          }
          validations
        }
        validations
      }
    }
    accountGlobalSharedContext {
      allOperationTypes {
        id
        name
        operationOrder
        kind
      }
    }
  }
`;

const LOAD_EXECUTION_OPERATION_FROM_PLANNING_QUERY = gql `
  query($planningOperationId: ID!){
    groundContext {
      executionOperationFromPlanning(planningOperationId: $planningOperationId) {
        operationTypeId
        initializationErrors
        operationType {
          id
          name
          kind
        }
        periodIds
        periodIdsAttribute
        periods {
          id
          name
        }
        planningOperationId        
        operationDate
        observation
        activitiesAttributes {
          id
          personId
          person {
            id
            name
          }
          durationInHours
          durationInMinutes
          durationText
          startDate
          endDate
          patrimonyId
          patrimony {
            id
            description
          }
          implementId
          implement {
            id
            description
          }
        }
        exitMovementItemsAttributes {
          id
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
          }
          exitMovementItemLotsAttributes{
            id
          }
          hasItemInStorage
          packagingId
          packaging {
            id
            name
          }
          storageId
          storage {
            id
            name
          }
          hasCropLimit
          unitQuantity
          quantity
        }
        entryMovementItemsAttributes {
          id
         	itemId
          item {
            id
            name
            unit {
              id
              name
            }
          }
          quantity
          storageId
          storage {
            id
            name
          }
          validations
        }
        validations
      }
    }
    accountGlobalSharedContext {
      allOperationTypes {
        id
        name
        operationOrder
        kind
      }
    }
  }
`;

const CREATE_EXECUTION_OPERATION_MUTATION = gql `
  mutation($input: ExecutionOperationCreateInputObject!) {
    createExecutionOperation(input: $input) {
      operation {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
